import $ from 'jquery';
/* eslint-disable import/extensions,import/no-unresolved, */
import HotelCenterBaseAdExtensionView from '@bingads-webui-campaign-legacy/hotel-center-ad-extensions/shared/view/hotel-center-base-adextension-view';
import appState from '@bingads-webui-component-legacy/state/index';
import { fetchPaginationConfig } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
/* eslint-enable */

import { CalloutAdExtension } from '@bingads-webui/campaign-odata-schemas';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';

const associationTypeGridMap = {
  SubAccount: 'CalloutAdExtensionAccountSubAccount',
  HotelGroup: 'CalloutAdExtensionAccountHotelGroup',
};

const CreateCalloutExtensionGrid = ({
  associationType,
  createAssociationEditorForUiNext,
  columns,
  i18n,
  toolbarPlugin,
  perfMarker,
}) => {
  const getGridPreferencesPromise = getGridPreferences({
    gridName: associationTypeGridMap[associationType],
    dateUtil: {
      format: value => i18n.formatDate(value),
    },
    state: appState,
    fetchPaginationConfig,
  });

  return getGridPreferencesPromise.then((preferenceConfig) => {
    const injectedview = new HotelCenterBaseAdExtensionView({
      associationType,
      schema: CalloutAdExtension,
      createAssociationEditorForUiNext,
      columns,
      typeString: i18n.getString(_TL_('Callout Extensions')),
      overThresholdErrorMessage: i18n.getString(_TL_('Your current selection has more callout extensions than can be displayed. Select a specific campaign or ad group to narrow down the number of callouts or use Bing Ads Editor.')),
      uinextToolbarPlugin: toolbarPlugin,
      perfMarker,
      isUINext: true,
      extendPlugins: () => ([toolbarPlugin]),
      preferenceConfig,
      viewport: $('.callout-extension-table-page-container'),
      customHeaderOffset: () => $('.sticky-container').height(),
    });
    return injectedview;
  });
};


export const createSubAccountLevelCalloutExtensionGrid = ({
  createAssociationEditorForUiNext,
  columns,
  i18n,
  toolbarPlugin,
  perfMarker,
  serverContext,
  scope,
  permissions,
  preferenceService,
}) =>
  CreateCalloutExtensionGrid({
    associationType: 'SubAccount',
    createAssociationEditorForUiNext,
    columns,
    i18n,
    toolbarPlugin,
    perfMarker,
    serverContext,
    scope,
    permissions,
    preferenceService,
  });


export const createHotelGroupLevelCalloutExtensionGrid = ({
  createAssociationEditorForUiNext,
  columns,
  i18n,
  toolbarPlugin,
  perfMarker,
  serverContext,
  scope,
  permissions,
  preferenceService,
}) =>
  CreateCalloutExtensionGrid({
    associationType: 'HotelGroup',
    createAssociationEditorForUiNext,
    columns,
    i18n,
    toolbarPlugin,
    perfMarker,
    serverContext,
    scope,
    permissions,
    preferenceService,
  });
